export const transformUser = user => {
  var _user$photo;

  if (!user) return undefined;
  const photoUrl = 'photo' in user ? (_user$photo = user.photo) === null || _user$photo === void 0 ? void 0 : _user$photo.url : user.photo_url;
  return {
    id: user.id,
    login: user.login,
    profileUrl: user.profile_url,
    photoUrl: photoUrl || undefined
  };
};
export const transformPagination = _ref => {
  let {
    current_page,
    total_pages
  } = _ref;
  return {
    currentPage: current_page,
    totalPages: total_pages
  };
};
export const transformComment = (_ref2, isSystem) => {
  let {
    comment,
    user
  } = _ref2;
  if (!comment) return undefined;
  return {
    user: transformUser(user),
    text: comment,
    isSystem
  };
};
export const transformFeedback = _ref3 => {
  let {
    id,
    user,
    feedback,
    rating,
    created_at_ts,
    system_feedback,
    comment,
    is_system_comment,
    can_comment,
    can_change,
    can_delete,
    can_change_comment,
    can_delete_comment,
    localization
  } = _ref3;
  return {
    id,
    text: feedback,
    rating,
    user: transformUser(user),
    comment: transformComment(comment, !!is_system_comment),
    createdAt: created_at_ts,
    isSystem: system_feedback,
    canReply: can_comment,
    canChange: can_change,
    canDelete: can_delete,
    canChangeComment: can_change_comment,
    canDeleteComment: can_delete_comment,
    localization
  };
};
export const transformFeedbackResponse = _ref4 => {
  let {
    pagination,
    user_feedbacks
  } = _ref4;
  return {
    pagination: transformPagination(pagination),
    feedback: user_feedbacks.map(transformFeedback)
  };
};